import { QUERY_KEY_ENTITY, QUERY_KEY_TYPE } from '../../constants';
import { baseApi } from './base.api';

const LIST_TAG = `${QUERY_KEY_ENTITY.WL}_${QUERY_KEY_TYPE.LIST}`;
const DROP_TAG = `${QUERY_KEY_ENTITY.WL}_${QUERY_KEY_TYPE.DROPDOWN}`;
export const wlApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWLIDList: build.query({
      query: () => `/v1/whitelabel/get`,
      providesTags: [{ type: LIST_TAG }],
    }),
    getWLIDByID: build.query({
      query: (arg) => `/v1/whitelabel/general-info/${arg}`,
      providesTags: (res, err, arg) => [
        { type: QUERY_KEY_ENTITY.WL, id: Number(arg) || 0 },
      ],
    }),
    getWLIDDropdown: build.query({
      query: () => `/v1/reports/wlid-list`,
      transformResponse: (response) =>
        response?.length
          ? response
              .map((item) => ({
                ...item,
                value: item.id,
                label: `(${item.wlid}) ${item.platformName}`,
              }))
              .sort((a, b) => b.wlid - a.wlid)
          : [],
      providesTags: [{ type: DROP_TAG }],
    }),
    updateWLIDBiddingStatus: build.mutation({
      query: (args) => ({
        url: `/v1/whitelabel/bidding`,
        method: 'PUT',
        body: args,
      }),
      invalidatesTags: (res, err, arg) => [
        { type: LIST_TAG },
        { type: DROP_TAG },
        ...arg.clientIds.map((id) => ({
          type: QUERY_KEY_ENTITY.WL,
          id: Number(id),
        })),
      ],
    }),
    updateWLIDGeneralByID: build.mutation({
      query: ({ id, ...payload }) => ({
        url: id ? `/v1/whitelabel/update/${id}` : '/v1/whitelabel/add',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (res, err, arg) => [
        { type: LIST_TAG },
        { type: DROP_TAG },
        { type: QUERY_KEY_ENTITY.ENDPOINT },
        ...(arg.id
          ? [{ type: QUERY_KEY_ENTITY.WL, id: Number(arg.id) || 0 }]
          : []),
      ],
    }),
    updateWLIDSettings: build.mutation({
      query: ({ id, ...payload }) => ({
        url: `/v1/whitelabel/update/${id}/settings`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: (res, err, { id }) => [
        { type: QUERY_KEY_ENTITY.WL, id: Number(id) || 0 },
      ],
    }),
    forceSyncWLID: build.mutation({
      query: (ids) => ({
        url: '/v1/whitelabel/force-sync',
        method: 'POST',
        body: { ids },
      }),
    }),
    signInAs: build.mutation({
      query: (payload) => ({
        url: '/v1/auth/sign-to',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});
export const {
  useGetWLIDListQuery,
  useGetWLIDByIDQuery,
  useGetWLIDDropdownQuery,
  //
  useUpdateWLIDGeneralByIDMutation,
  useUpdateWLIDBiddingStatusMutation,
  useUpdateWLIDSettingsMutation,
  useForceSyncWLIDMutation,
  useSignInAsMutation,
} = wlApi;
